/**
 * Rend la main au navigateur (rendu, clics) le temps d'une tâche. Pas de
 * `setTimeout` : limité à 4 ms en boucle, et à un par minute sur une page masquée.
 */
export const yieldToBrowser = (): Promise<void> =>
  new Promise((resolve) => {
    const channel = new MessageChannel();
    channel.port1.onmessage = () => {
      channel.port1.close();
      resolve();
    };
    channel.port2.postMessage(null);
  });
